import React from "react"
import {CmCollection, CmTeasable} from "../../../../packages/graphql-layer/src";
import CCOHeadline from "../../fundamentals/CCOHeadline";
import C000DefaultTeaser from "./C000DefaultTeaser";


export interface Props {
    cmCollection: CmCollection
}

function C000DefaultCollection(props: Props) {
    return <>
        <CCOHeadline metadataId={props.cmCollection.id} headline={props.cmCollection.teaserTitle}
                     type={"componenthead"}
                     propertyName='properties.teaserTitle'
                     subtextPropertyName='properties.teaserText'
                     subtext={props.cmCollection.teaserText?.textAsTree}/>

        {
            props.cmCollection.items?.map(i => i as CmTeasable).map((i: CmTeasable, index: number) =>
                <C000DefaultTeaser cmTeasable={i} key={index}/>
            )
        }
    </>

}

export default C000DefaultCollection